import { CustomOfferItemPreviewV2 } from 'components';
import { OptionalItemPreview } from 'components/Offer';
import { offer } from 'data';
import { formatPrice } from 'helpers/formatters';
import { useSelector } from 'hooks';
import { styled } from 'mymoria-ui';
import React from 'react';
import OfferPageCard from './OfferPageCard';

const StyledCard = styled(OfferPageCard)(
  `
    && {
      padding: 1.5rem 0;
    }

    & > div:first-of-type {
      padding: 0 1.5rem;
      margin-bottom: 1rem;
      & + hr {
        display: none;
      }
    }

    & > hr {
      & + hr {
        display: none;
      }
      &:last-child {
        display: none;
      }
    }
  `,
);

const SelectedOptionalItemsCard = () => {
  const products = useSelector(({ proposal }) => proposal.optionalProducts);
  const services = useSelector(({ proposal }) => proposal.optionalServices);
  const extras = useSelector(({ proposal }) => proposal.extras);

  const items = [
    ...products.map(id => <OptionalItemPreview key={id} id={id} type="products" />),
    ...services.map(id => <OptionalItemPreview key={id} id={id} type="services" />),
    ...(extras || [])
      .filter(({ category }) => category !== 'serviceDiscount')
      .map(
        ({
          id,
          translations: { shortname, description },
          price,
          pictures,
          quantity,
          placeholder,
        }) => (
          <CustomOfferItemPreviewV2
            id={id}
            key={id}
            selected
            name={shortname}
            price={price}
            priceFormatter={formatPrice}
            image={pictures[0] || placeholder}
            description={description}
            quantity={quantity}
          />
        ),
      ),
  ].flatMap((node, index, array) =>
    index === array.length - 1 ? node : [node, <hr key={`separator-${index}`} />],
  );

  if (items.length === 0) {
    return null;
  }

  return <StyledCard title={offer.offerDetails.othersTitle}>{items}</StyledCard>;
};

export default SelectedOptionalItemsCard;
